/* eslint-disable */
export default {
  ringtones: 'Beltonen',
  incomingRingtone: 'Beltoon inkomende oproep',
  outgoingRingtone: 'Beltoon uitgaande oproep',
  play: 'Afspelen',
  stop: 'Stoppen',
  upload: 'Uploaden',
  reset: 'Resetten',
  save: 'Opslaan',
} as const;

// @key: @#@"ringtones"@#@ @source: @#@"Ringtones"@#@
// @key: @#@"incomingRingtone"@#@ @source: @#@"Incoming Ringtone"@#@
// @key: @#@"outgoingRingtone"@#@ @source: @#@"Outgoing Ringtone"@#@
// @key: @#@"play"@#@ @source: @#@"Play"@#@
// @key: @#@"stop"@#@ @source: @#@"Stop"@#@
// @key: @#@"upload"@#@ @source: @#@"Upload"@#@
// @key: @#@"reset"@#@ @source: @#@"Reset"@#@
// @key: @#@"save"@#@ @source: @#@"Save"@#@
